import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type LayersThree02IconProps = IconProps

const LayersThree02Icon = forwardRef<SVGSVGElement, LayersThree02IconProps>(
  (props: LayersThree02IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 9.5 2 12l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12l-5-2.5m-10 5L2 17l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 17l-5-2.5M2 7l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 7l-9.642 4.821a1.028 1.028 0 0 1-.266.111.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 7Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

LayersThree02Icon.displayName = 'LayersThree02Icon'
LayersThree02Icon.defaultProps = iconDefaultProps

export type { LayersThree02IconProps }
export { LayersThree02Icon }
